export default "__VITE_ASSET__DDO87sJg__"